let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

$(function() {

	detect_browser();	

	resize_utils();    

});



$(window).on('load', function(){

	$('body').removeClass('loading');
	
});




$(window).on('resize', function(){

	resize_utils();
    
});

var resizeTimer;
function resize_utils(){

	$('body').addClass('resizing');

	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {

		$('body').removeClass('resizing');
	        
	}, 250);
}


function isDesktop(){
	return $(document).width() > 1024;
}

function isMobile(){
	return $(document).width() < 768;
}






function is_touch_device() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}


function detect_browser(){
    if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) 
    {
        $('body').addClass('opera');
    }
    else if(navigator.userAgent.indexOf("Chrome") != -1 )
    {
        $('body').addClass('chrome');
    }
    else if(navigator.userAgent.indexOf("Safari") != -1)
    {
        $('body').addClass('safari');
    }
    else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
    {
         $('body').addClass('firefox');
    }
    else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
    {
      $('body').addClass('ie');
    }  
    else 
    {
       $('body').addClass('unknown-browser');
    }
    
}

